import {
  GET_GOOGLE_RATING
} from '@/utils/store/actionTypes'
import { formatNumber } from '@/utils/general'

export default {
  /**
   * Gets the google start rating plus amount of google ratings
   *
   */
  async [GET_GOOGLE_RATING] () {
    const response = await this.$axios.$get(`${process.env.API_URL}/v2/google-rating`, {
      headers: {
        ContentType: 'application/json',
        Accept: 'application/json'
      },
      withCredentials: false
    })

    return { ...response, ratingTotal: formatNumber(response.ratingTotal) }
  }
}
